import React, { useState, useEffect } from 'react'
import { PropsWithChildren } from 'react'
import userStore from 'stores/user'
import { useObservable } from 'utils/use-observable'
import { AccessGroupApis } from 'views/order/v5/api/access-groups-api'

export default function SecurityCheck(props: PropsWithChildren<any>) {
  const [loggedIn] = useObservable(userStore.loggedIn, false)
  const [hasAccess, setHasAccess] = useState(true)

  useEffect(() => {
    if (loggedIn) {
      Promise.all([AccessGroupApis.isAuthorized('restaurants'), AccessGroupApis.isAuthorized('channels')]).then(
        (checks: { is_authorized: boolean }[]) => {
          const res = checks.find(({ is_authorized }) => is_authorized) || { is_authorized: false }
          setHasAccess(res.is_authorized)
          if (!res.is_authorized) {
            const timeOut = setTimeout(() => {
              window.location.href = 'https://zuppler.com'
            }, 1500)
            return () => clearTimeout(timeOut)
          }
          return () => {}
        }
      )
    }
  }, [loggedIn])

  return hasAccess ? <>{props.children}</> : <>401 Access Denied</>
}
